export default __webpack_public_path__ + "static/media/project2.91529eb8.png";